/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react/macro';

import { Link } from 'components/Link';
import { Text, TextAlign } from 'components/Text';
import { useStyles } from 'utils/useStyles';

interface DisclaimerProps {
  trackingQueryParams?: string;
  align?: string;
}

export const Disclaimer = ({ trackingQueryParams = '', align = 'left' }: DisclaimerProps) => {
  const styles = useStyles(getStyles);

  return (
    <Text id="disclaimer" type="normal" align={align as TextAlign}>
      <span css={styles.main}>
        By creating an account, or by using an SSO provider to create one, I agree to the{' '}
        <Link
          id="disclaimer-terms"
          to={`/legal/terms${trackingQueryParams}`}
          type="external"
          label="Terms of Service"
        />{' '}
        and{' '}
        <Link
          id="disclaimer-msa"
          to={`/legal/msa${trackingQueryParams}`}
          type="external"
          label="Master Services Agreement"
        />
        , and acknowledge the{' '}
        <Link
          id="disclaimer-privacy"
          to={`/legal/privacy-policy${trackingQueryParams}`}
          type="external"
          label="Privacy Policy"
        />
        .
      </span>
    </Text>
  );
};

const getStyles = () => ({
  main: css`
    text-align: center;

    a {
      text-decoration: underline;
    }

    /* Body Small */
    font-family: Inter;
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
    letter-spacing: 0.018px;
    grid-row-start: row1-start;
  `,
});
